<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 工作台 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="{}">
        <el-form-item label="数据范围">
          <el-select
            v-model="formInline.apiType"
            @change="queryClick"
            style="width: 140px; margin-right: 10px"
            placeholder="订单类型"
          >
            <el-option label="选中门店" value=""></el-option>
            <el-option label="全部门店" value="allStore"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店仓库" v-if="formInline.apiType != 'allStore'">
          <customer-store-select
            :defaultFirst="true"
            style="width: 180px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="订单类型">
          <el-select
            v-model="formInline.orderType"
            @change="queryClick"
            style="width: 140px; margin-right: 10px"
            placeholder="订单类型"
          >
            <el-option label="全部类型" value=""></el-option>
            <el-option label="线下订单" value="offline"></el-option>
            <el-option label="渠道订单" value="other"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单渠道" v-if="formInline.orderType == 'other'">
          <customer-order-channel-select
            v-model="formInline.orderChannelGuid"
            @change="queryClick"
            style="width: 140px; margin-right: 10px"
            :clearable="true"
            placeholder="订单渠道"
          />
        </el-form-item>
        <time-range @change="handleTimeChange">
          <template slot="append">
            <div style="margin-right: 10px">
              <el-select
                v-model="analysisMode"
                :size="$xUISize"
                style="width: 100px"
                placeholder="统计类型"
              >
                <el-option label="增长值" value="increase"></el-option>
                <el-option label="比较值" value="ratio"></el-option>
              </el-select>
            </div>
            <div>
              <el-popover
                title="扫码下载客户端"
                placement="bottom"
                trigger="hover"
                width="330"
              >
                <app-download-qr-code :imageSize="200"></app-download-qr-code>
                <el-button :size="$xUISize" style="margin-right: 10px" slot="reference">
                  下载客户端
                </el-button>
              </el-popover>
              <el-button
                style="margin-right: 10px"
                @click="fetchOrderAnalysis"
                :size="$xUISize"
              >
                刷新
              </el-button>
            </div>
          </template>
        </time-range>
      </el-form>
    </el-card>
    <template v-if="storeGuid && orderAnalysisData">
      <el-card shadow="hover" style="margin-bottom: 12px">
        <div slot="header" class="clearfix">
          <span> 经营数据分析 </span>
        </div>
        <div style="padding: 20px">
          <div class="row">
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="营业金额"
                unit="元"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderTotalAmount"
                :last-value="orderAnalysisData.lastData.orderTotalAmount"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderTotalAmount
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="预计收入"
                unit="元"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderSettlementAmount"
                :last-value="orderAnalysisData.lastData.orderSettlementAmount"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderSettlementAmount
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="有效订单数量"
                unit="单"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderCount"
                :last-value="orderAnalysisData.lastData.orderCount"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderCount
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="订单渠道成本"
                unit="元"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderOrderChannelCost"
                :last-value="orderAnalysisData.lastData.orderOrderChannelCost"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderOrderChannelCost
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="收款渠道成本"
                unit="元"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderPaymentChannelCost"
                :last-value="orderAnalysisData.lastData.orderPaymentChannelCost"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderPaymentChannelCost
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="客单价"
                unit="元"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderUnitPrice"
                :last-value="orderAnalysisData.lastData.orderUnitPrice"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderUnitPrice
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="包装收费"
                unit="元"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderPackAmount"
                :last-value="orderAnalysisData.lastData.orderPackAmount"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderPackAmount
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="配送收费"
                unit="元"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderFreightAmount"
                :last-value="orderAnalysisData.lastData.orderFreightAmount"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderFreightAmount
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="销售商品成本"
                unit="元"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderOutboundGoodsCost"
                :last-value="orderAnalysisData.lastData.orderOutboundGoodsCost"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderOutboundGoodsCost
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="退货商品成本"
                unit="元"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderReturnGoodsCost"
                :last-value="orderAnalysisData.lastData.orderReturnGoodsCost"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderReturnGoodsCost
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="配送费用成本"
                unit="元"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderFreightCost"
                :last-value="orderAnalysisData.lastData.orderFreightCost"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderFreightCost
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="平均配送成本"
                unit="元"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderUnitFreightCost"
                :last-value="orderAnalysisData.lastData.orderUnitFreightCost"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderUnitFreightCost
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="预估毛利"
                unit="元"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderProfitAmount"
                :last-value="orderAnalysisData.lastData.orderProfitAmount"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderProfitAmount
                "
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <analysis-item
                title="毛利润率"
                unit="%"
                :mode="analysisMode"
                :current-value="orderAnalysisData.orderProfitRate"
                :last-value="orderAnalysisData.lastData.orderProfitRate"
                :show-time-value="!!orderAnalysisData.lastTimeData"
                :time-value="
                  orderAnalysisData.lastTimeData &&
                  orderAnalysisData.lastTimeData.orderProfitRate
                "
              />
            </div>
          </div>
        </div>
      </el-card>
    </template>
    <el-card v-else-if="!loading" shadow="hover">
      <el-empty :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="fetchOrderAnalysis" size="small">
          重新加载
        </el-button>
      </el-empty>
    </el-card>
    <el-card v-else shadow="hover">
      <div slot="header" class="clearfix">
        <span> 正在加载数据中 </span>
      </div>
      <div v-loading="loading" style="min-height: 100px"></div>
    </el-card>
  </div>
</template>

<script>
import appDownloadQrCode from "./__app_download_qr.vue";
import analysisItem from "../../../components/analysisItem.vue";
import customerStoreSelect from "../../../components/business/customerStoreSelect.vue";
import customerOrderChannelSelect from "../../../components/business/customerOrderChannelSelect.vue";
import timeRange from "../../../components/timeRange.vue";

export default {
  components: {
    timeRange,
    analysisItem,
    customerStoreSelect,
    customerOrderChannelSelect,
    appDownloadQrCode,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
      this.fetchOrderAnalysis();
    },
  },
  data() {
    return {
      times: null,
      loading: false,
      errorMsg: null,
      queryModel: {},
      formInline: {
        apiType: "",
        orderType: "",
        orderChannelGuid: "",
      },
      analysisMode: "increase",
      orderAnalysisData: null,
      storeGuid: "",
    };
  },
  methods: {
    clearClick() {
      this.formInline = {
        apiType: "",
        orderType: "",
        orderChannelGuid: "",
      };
      this.queryModel = {};
    },
    queryClick() {
      if (this.formInline.orderType != "other") {
        this.formInline.orderChannelGuid = "";
      }
      this.queryModel = Object.assign({}, this.formInline);
      this.fetchOrderAnalysis();
    },
    handleTimeChange(time) {
      this.times = time;
      this.fetchOrderAnalysis();
    },
    fetchOrderAnalysis() {
      if (!this.storeGuid) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.orderAnalysisData = null;
      this.purchaseAnalysisData = null;
      this.storeReplenishAnalysisData = null;
      this.storehouseReplenishAnalysisData = null;
      this.requestApi(
        this.queryModel.apiType == "allStore"
          ? "biz.warehouse.order.info.analysisAllStore"
          : "biz.warehouse.order.info.analysis",
        Object.assign(
          {
            storeGuid: this.storeGuid,
          },
          this.queryModel,
          this.times
        )
      )
        .then((resp) => {
          this.orderAnalysisData = resp.data;
        })
        .catch((err) => {
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
    this.fetchOrderAnalysis();
  },
};
</script>
